import { render, staticRenderFns } from "./ReportBlockHeader.vue?vue&type=template&id=7d70998c&scoped=true"
import script from "./ReportBlockHeader.vue?vue&type=script&lang=js"
export * from "./ReportBlockHeader.vue?vue&type=script&lang=js"
import style0 from "./ReportBlockHeader.vue?vue&type=style&index=0&id=7d70998c&prod&lang=css"
import style1 from "./ReportBlockHeader.vue?vue&type=style&index=1&id=7d70998c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d70998c",
  null
  
)

export default component.exports